import { axiosGet, axiosPost } from "./ajaxServices";
import {
  urlSendEmailCampaign,
  urlGetEmailCampaigns,
  urlGetEmailCampaignDetail,
} from "./CONSTANTS";

/**
 * Send an email campaign
 * @param {Object} payload - { token, club_id, subject, html, to_emails[], cc_emails[], bcc_emails[], audience_names[], attachment?: { file_name, file_base64 } }
 * @returns {Promise<{campaign_id, recipients_count}>}
 */
export async function sendEmailCampaign(payload) {
  return await axiosPost(
    urlSendEmailCampaign,
    payload,
    "Failed to send email campaign"
  );
}

/**
 * Get list of email campaigns (summary view)
 * @param {Object} params - { token, club_id, page?, page_size? }
 * @returns {Promise<Array<{campaign_id, subject, audience_names[], recipients_count, created_at, has_attachment}>>}
 */
export async function getEmailCampaigns(params) {
  const res = await axiosGet(
    urlGetEmailCampaigns,
    params,
    "Failed to load email campaigns"
  );
  // Handle both array response and object with campaigns property
  if (Array.isArray(res)) {
    return res;
  } else if (res && Array.isArray(res.campaigns)) {
    return res.campaigns;
  }
  return [];
}

/**
 * Get detailed information for a specific campaign
 * @param {Object} params - { token, campaign_id }
 * @returns {Promise<{campaign_id, subject, audience_names[], recipients_count, created_at, html, attachment?, recipients[]}>}
 */
export async function getEmailCampaignDetail(params) {
  const res = await axiosGet(
    urlGetEmailCampaignDetail,
    params,
    "Failed to load campaign details"
  );
  // Extract campaign object from response
  if (res && res.campaign) {
    return res.campaign;
  }
  // Fallback: return response as-is if structure is different
  return res;
}
